<template>
  <vx-card>
    <template>
      <h4 class="mb-5">Produtos</h4>
      <div class="flex flex-wrap-reverse items-center">
        <!-- ADD NEW -->
        <div @click="activeProductPrompt" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
          <feather-icon
           icon="PlusIcon"
           svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Novo</span>
        </div>
      </div>
      <vs-prompt
       @cancel="newProduct=null"
       @accept="productAdded"
       accept-text="Adicionar"
       cancel-text="Cancelar"
       title="Selecione os produtos"
       :active.sync="addProductPrompt">
        <v-select
         v-model="data.newProduct"
         multiple
         :filter="filterProducts"
         :options="getProducts"
         :getOptionLabel="option => option.codigo">
          <template v-slot:option="option">
            <h6 style="margin: 0">{{ option.codigo }}</h6>
            <span style="font-size: 12px;">{{ option.descricaoPTBR }}</span>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em
             style="opacity: 0.5;"
             v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
      </vs-prompt>
      <vs-prompt
       @cancel="redirectToIndex"
       @accept="saveTemplate"
       accept-text="Salvar"
       cancel-text="Cancelar"
       title="Digite o nome do template"
       :active.sync="saveTemplatePrompt">
        <vs-input v-model="data.templateName" class="w-full"></vs-input>
      </vs-prompt>
      <vs-table ref="table" :max-items="1000" :noDataText="'Nenhum produto adicionado'" :data="data.addedProducts">
        <template slot="thead">
          <vs-th>Imagem</vs-th>
          <vs-th>Descrição</vs-th>
          <vs-th>Marca</vs-th>
          <vs-th>Modelo</vs-th>
          <vs-th>Link Tray</vs-th>
          <vs-th>Ações</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="data.addedProducts" :key="indextr" v-for="(product, indextr) in data">
              <vs-td>
                <img
                 v-if="product.imageUrl"
                 key="onlineImg"
                 :src="product.imageUrl"
                 alt="product-img"
                 width="70"
                 style="height: 70px"
                 class="rounded-full shadow-md inline-block" />
                <p v-else class="text-center font-medium">-</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.descricaoPTBR }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.marca }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.modelo }}</p>
              </vs-td>
              <vs-td>
                <a target="_blank" rel="noopener noreferrer" :href="product.trayUrl">{{ product.trayUrl }}</a>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                 icon="Trash2Icon"
                 svgClasses="w-5 h-5 hover:text-danger stroke-current"
                 class="ml-2 cursor-pointer"
                 @click.stop="deleteData(product)" />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div v-if="!(data.addedProducts).length">
        <vs-input name="jsonProdutos" v-model="jsonProdutosToValidate" v-validate="'required'" class="hidden w-full"></vs-input>
        <span class="text-danger text-sm" v-show="errors.has('jsonProdutos')">{{ errors.first('jsonProdutos') }}</span>
      </div>
    </template>
    <div class="flex flex-wrap items-center" slot="footer">
      <vs-button class="mr-6" @click="generateTemplate()">Gerar</vs-button>
    </div>
  </vx-card>
</template>
<script>
import helpers from "@/helpers"
import axios from "axios"
import Fuse from "fuse.js"
import { baseApiUrl } from "@/global"
import { Validator } from 'vee-validate';

const dict = {
    custom: {
        jsonProdutos: { required: 'Selecione ao menos 1 produto' },
    }
};

Validator.localize('en', dict);


export default {
    data() {
        return {
            data: { addedProducts: [] },
            helpers: null,
            addProductPrompt: false,
            saveTemplatePrompt: false,
            jsonProdutosToValidate: null,
        }
    },
    computed: {
        getProducts() {
            return this.$store.state.products
        },
    },
    methods: {
        activeProductPrompt() {
            this.addProductPrompt = true
        },
        productAdded() {
            this.data.addedProducts.push(...this.data.newProduct)
            this.data.newProduct = null
        },
        deleteData(data) {
            this.data.addedProducts = this.data.addedProducts.filter(el => !(el == data))
        },
        filterProducts(options, search) {
            const fuse = new Fuse(options, {
                keys: ['codigo', 'descricaoPTBR'],
                shouldSort: true,
                threshold: 0.1,
                distance: 100,
            });
            let fuseSearch = []
            for (let item of fuse.search(search)) {
                fuseSearch.push(item.item)
            }
            return search.length ? fuseSearch : fuse.list;
        },
        addProductToTable(productData) {
            this.data.addedProducts.push(productData)
        },
        redirectToIndex() {
            this.$router.push({ name: 'marketing-list' })
        },
        async generateTemplate() {
            let haveErrors = !(await this.$validator.validateAll())
            if (haveErrors)
                return

            this.$vs.dialog({
                type: 'confirm',
                title: `Salvar Template`,
                acceptText: 'Sim',
                cancelText: 'Não',
                text: 'Você deseja salvar este template para utilizar futuramente?',
                accept: this.saveTemplate,
                cancel: this.redirectToIndex
            })

            //download html file
        },
        async saveTemplate() {

            if (!this.data.templateName) {
                this.saveTemplatePrompt = true
                return
            }

            const addedProducts = _.map(this.data.addedProducts, _.partial(_.pick, _, [
                'codigo'
            ]));

            const formData = {
                nome: this.data.templateName,
                produtos: JSON.stringify(addedProducts)
            }

            try {
                this.$vs.loading()
                await axios.post(`${baseApiUrl}/marketing/saveTemplate`, formData)
                this.redirectToIndex()
                this.$vs.notify({
                    color: 'success',
                    title: 'Template Salvo',
                    text: `O template ${formData.nome} foi salvo!`
                })
            } catch (error) {
                this.$vs.notify({
                    title: 'Erro',
                    text: error.response.data,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close()
            }
        }
    },
    created() {
        this.helpers = helpers
        let payload = {
            loading: this.$vs.loading
        }
        this.$store.dispatch("fetchProductsItems", payload)
    }

}

</script>
